import { TPlayerLayoutStylesSchema } from './PlayerLayout.styles';

const styles: Partial<TPlayerLayoutStylesSchema> = {
  row: {
    borderBottomWidth: '1px',
    borderBottomColor: 'rgba(255, 255, 255, .15)',
    pb: '2',
    boxShadow: '1px -1.5px 0px -1px #292f36 inset',
  },

  propWrapper: {
    justifyContent: 'flex-end',
  },
  btnGroupWrapper: {
    borderRadius: '5px',
    bgGradient: 'linear(to-b, alpha.400, alpha.500)',
    boxShadow: `0px 4px 4px 0px rgba(0, 0, 0, 0.25),0px 3px 0px 0px #480,0px 1px 0px 0px rgba(255, 255, 255, 0.40) inset,0px 0px 0px 1px rgba(255, 255, 255, 0.20) inset`,
    minW: '90px',
    gap: '1',
  },
  btnGroupText: {
    fontSize: 'sm',
    color: 'alpha.800',
    fontWeight: 'black',
    fontFamily: 'roboto',
    textShadow: '1px 0px 0px rgba(255, 255, 255, 0.45)',
  },
  btnGroupIcon: {
    color: 'alpha.800',
    sx: {
      h: '5',
      w: '7',
    },
  },
  name: {
    color: 'alpha.800',
  },
};
export default styles;
